"use strict";
exports.__esModule = true;
exports.synthesizeString = void 0;
function synthesizeString(schema, options) {
    return 'string';
}
exports.synthesizeString = synthesizeString;
